import { render, staticRenderFns } from "./authoritysearch.vue?vue&type=template&id=0c894990&scoped=true&"
import script from "./authoritysearch.vue?vue&type=script&lang=js&"
export * from "./authoritysearch.vue?vue&type=script&lang=js&"
import style0 from "./authoritysearch.vue?vue&type=style&index=0&id=0c894990&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c894990",
  null
  
)

export default component.exports